import { Component } from '@angular/core';

@Component({
    selector: 'leavesAndHoliday',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class LeavesAndHolidaysComponent {}
